// extracted by mini-css-extract-plugin
export default {"calcPage":"Calculator_calcPage__HCee3","calc":"Calculator_calc__ozRW9","output":"Calculator_output__IS8gJ"};